import moment from 'moment';
import SA from '../actions/sessionActions';
import { Request } from '../../utils/commonUtils';
import { htmlStorage } from '../../utils/sessionUtils';
const init = {
    status: '',
    error: null,
    token: ''
};

export default (state=init, action) => {
    switch(action.type) {
        case SA.PENDING_SESSION_LOGIN:
            return {...state, status: 'pending' };

        case SA.SUCCESS_SESSION_LOGIN:
            return {...state, status: 'success', token: action.payload };

        case SA.FAILURE_SESSION_LOGIN:
            return {...state, status: 'failure', error: action.payload };

        case SA.RESET_SESSION_LOGIN:
            return {...init};

        default: return {...state}
    }
}
